// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"c72f0fb6","522":"c106fdaf"}[chunkId] + ".chunk.js";
};